const transformGroupedData = (groupedData, setSummaryStats) => {
  if (!groupedData) return [];

  const transformedData = Object.entries(groupedData).flatMap(
    ([date, entries]) =>
      entries.map((entry, index) => {
        const doneValues = entry.done?.split(",").map(Number);
        const targetValues = entry.target?.split(",").map(Number);
        const modIdValues = Array.isArray(entry.modId) ? entry.modId : [];
        const totalDone = doneValues?.reduce((sum, num) => sum + num, 0);
        const totalTarget = targetValues?.reduce((sum, num) => sum + num, 0);
        return {
          key: `${date}-${index}`,
          date,
          projectName: entry.projectName,
          subProject: entry.subProject,
          department: entry.department,
          subject: entry.subject,
          done: entry.done || 0,
          target: entry.target || "N/A",
          modId: modIdValues.map((id) => id.trim()).join(", "),
          qualitative: entry.qualiRecords,
          progress:
            totalTarget > 0
              ? Math.min(Math.round((totalDone / totalTarget) * 100), 100)
              : 0,
        };
      })
  );

  // Calculate summary statistics
  if (transformedData.length > 0) {
    const totalDone = transformedData.reduce(
      (sum, item) => sum + (typeof item.done === "number" ? item.done : 0),
      0
    );
    const totalTarget = transformedData.reduce(
      (sum, item) => sum + (typeof item.target === "number" ? item.target : 0),
      0
    );
    const overallProgress =
      totalTarget > 0
        ? Math.min(Math.round((totalDone / totalTarget) * 100), 100)
        : 0;
    const uniqueModerators = new Set(
      transformedData.flatMap((item) => item.modId.split(", "))
    ).size;

    setSummaryStats({
      totalDone,
      totalTarget,
      overallProgress,
      uniqueModerators,
    });
  }

  return transformedData;
};
export default transformGroupedData;
